/* eslint-disable no-unused-vars */
import React, {
  useState, useEffect, useRef, useMemo,
} from 'react';
import {
  colors, Container, Figure, Line, Div, Row,
} from 'globalStyle';
import { Navbar } from 'Layout/components/Navbar';
import arrowLeft from 'assets/icons/arrowLeftHeader.svg';
import InvestmentConditions from 'page/components/InvestmentConditions/index';
import { SubTitle, Text, Title } from 'components/Texts';
import { routes } from 'routes';
import { Redirect, useRoute, useLocation as useWouterLocation } from 'wouter';
import {
  useSingleProject, useUser, useProjects, useMediaQuery, useCategorizations, useSearchParam,
} from 'hooks';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
} from '@material-ui/core';
import { formatNumber } from 'util/formatNumber';
import { CloseIcon } from 'icons';
import { Hollow, hollowColorType } from 'components/Buttons';
import { percent } from 'util/percent';
import { InputNumber } from 'components/Form';
import { projectStateType, userType } from 'types';
import { Card } from 'page/components/Card';
import { Helmet } from 'react-helmet-async';
import { Video } from 'page/components/Video';
import { Assets } from 'page/components/Assets';
import { useLocation } from 'hooks/useLocation';
import { SignUp } from 'components/Modals/SignUp';
import MobileSimulator from 'page/Profile/User/Simulator/MobileSimulator';
import { getStatusData } from 'util/getStatusProject';
import { CalculationSimulatorController } from 'controller/CalculationSimulatorController';
import RegisterChecker from 'Layout/components/Navbar/components/Register/components/RegisterChecker';
import { typeColorByProjectType, colorByProjectType } from 'types/projectType';
import { InvertModal } from './components/InvertModal';
import { Loading } from '../../components/Loading';
import { ListOfProject } from './components/ListOfProject';
import ProjectDetails from '../components/ProjectDetails';
import ProjectMeetCompany from '../components/ProjectMeetCompany';
import ProjectDescription from '../components/ProjectDescription';
import ProjectInvertButtons from '../components/ProjectInvertButtons';
import ProjectInfoCards from '../components/ProjectInfoCards';

const scrollTo = (height = 100) => {
  window.scrollTo({
    top: height,
    behavior: 'smooth',
  });
};

const CAROUSEL_HEIGHT = '70dvw';

export const ProjectMobile = () => {
  const isDesktop = useMediaQuery();
  const from = useSearchParam('from');
  const isBigPhone = useMediaQuery(340);
  const [, setRoute] = useWouterLocation();
  const [, params] = useRoute(routes.project.params);
  const {
    isLoadingSingleProject,
    isErrorSingleProject,
    singleProject,
  } = useSingleProject(params ?? {});
  const { isLoadingProjects, projects } = useProjects({
    type: projectStateType.OPEN,
  });
  const { categorizations, defaultCategorization } = useCategorizations();
  const categorization = useMemo(() => {
    if (
      categorizations
      && singleProject
      && from === 'categorization'
      && singleProject?.categorizationId !== defaultCategorization?.id
    ) {
      return categorizations?.find((v) => v?.id === singleProject?.categorizationId);
    }
    return undefined;
  }, [categorizations, singleProject]);
  const { location } = useLocation();
  const { user, isLogin, type } = useUser();
  const [open, setOpen] = useState(false);

  const isVipUser = user?.info?.userType === 'VIP_INVESTOR' || user?.info?.userType === 'VIP_COMPANY';
  const { nameStatus } = getStatusData(singleProject?.status);
  const [durationMonths, setDurationMonths] = useState();
  const [simulationInfo, setSimulationInfo] = useState({
    period: singleProject?.frequency,
    loanMonths: durationMonths,
    pctReturn: singleProject?.percent,
    paymentPeriod: singleProject?.frequency,
  });
  const [currentAmount, setCurrentAmount] = useState(0);
  const [percentValue, setPercent] = useState(0);
  const [maxAmount, setMaxAmount] = useState(0);
  const [detailsActiveItem, setDetailsActiveItem] = useState();
  const [showInvestorSimulator, setShowInvestorSimulator] = useState(false);
  const handlerSimulator = () => setShowInvestorSimulator(!showInvestorSimulator);
  const [descriptionTab, setDescriptionTab] = useState();
  const descriptionTeamRiskRef = useRef();
  const cardRef = useRef(null);
  const videoProject = useMemo(() => (singleProject?.videoUrl ? () => (
    <Video
      height={CAROUSEL_HEIGHT}
      url={singleProject?.videoUrl}
      onPlay={() => cardRef.current.isVisible(false)}
      onPause={() => cardRef.current.isVisible(true)}
      onEnded={() => cardRef.current.isVisible(true)}
    />
  ) : null), [singleProject]);
  const handleGoRisks = () => {
    scrollTo(descriptionTeamRiskRef.current?.offsetTop);
    setDetailsActiveItem('risks');
  };
  useEffect(() => {
    setCurrentAmount(singleProject?.currentAmount);
    setPercent(percent(singleProject?.currentAmount, singleProject?.minAmount));
    setMaxAmount(singleProject?.maxAmount);
  }, [singleProject?.currentAmount]);
  useEffect(() => {
    if (location.previous === '/perfil/inversiones') {
      handleGoRisks();
    }
  }, [isLoadingProjects]);
  const [isOpenModal, setOpenModal] = useState({
    signUp: false,
    completeProfile: false,
    investor: false,
    completeProfileQR: false,
  });
  const handleInvertModal = () => {
    let state = {};

    if (!isLogin) {
      state = { ...isOpenModal, signUp: true };
    } else if (user.info.status === 'PENDING_FORMS') {
      state = { ...isOpenModal, completeProfile: true };
    } else {
      state = { ...isOpenModal, investor: true };
    }

    setOpenModal(state);
  };
  const handleCloseModal = () => {
    setOpenModal({
      signUp: false,
      completeProfile: false,
      investor: false,
      completeProfileQR: false,
    });
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSimulationChange = async (e) => {
    const simulation = e.target.name === 'goal'
      ? { ...simulationInfo, [e.target.name]: Number(e.target.value) }
      : { ...simulationInfo, [e.target.name]: e.target.value };

    setSimulationInfo(simulation);
  };

  if (isLoadingSingleProject || !singleProject) return <Loading />;
  if (isErrorSingleProject) return <Redirect to="/404" />;
  return (
    <div>
      <Navbar
        buttonsColor={categorization?.color}
        customLogo={categorization && (
          <Figure
            ml={!isDesktop && 38}
            width={isDesktop ? '189px' : '130px'}
            maxHeight={isDesktop ? '70px' : '30px'}
            onClick={() => setRoute(routes.invert)}
            style={{ position: 'relative', cursor: 'pointer' }}
          >
            <img
              alt="logo"
              src={categorization?.logo.temporalResource}
              style={{
                maxHeight: '55px',
                objectFit: 'scale-down',
                objectPosition: 'center center',
              }}
            />
          </Figure>
        )}
      />
      {singleProject && (
        <Helmet>
          <meta
            name="description"
            content={singleProject.shortDescription}
          />
        </Helmet>
      )}
      <Box>
        <Assets
          video={videoProject}
          height={CAROUSEL_HEIGHT}
          photoProduct={singleProject?.images}
        >
          <Card
            ref={cardRef}
            color={categorization?.color}
            projectName={singleProject?.projectName}
            statusProject={singleProject?.status}
            companyName={singleProject?.companyName}
            shortDescription={singleProject?.shortDescription}
            currentAmount={currentAmount}
            maxAmount={maxAmount}
            percent={percentValue}
            endDate={singleProject?.endDate}
            currentInvestorsAmount={singleProject?.currentInvestorsAmount}
            timeStimated={singleProject?.timeStimated}
            closureDate={singleProject?.closureDate}
            isOpen={singleProject?.status === projectStateType.OPEN}
            onClick={handleInvertModal}
            daysLeft={singleProject?.daysLeft}
            projectInfo={singleProject}
            {...singleProject}
            disabled={singleProject?.status !== projectStateType.OPEN || isVipUser}
            images={singleProject.images}
            isLogin={isLogin}
            userData={user?.info}
            singleProject={singleProject}
            projectId={singleProject?.projectId}
            name={singleProject?.projectName}
            percentValue={percentValue}
            onRisk={handleGoRisks}
            onSuccessfulInvert={(amount) => {
              setCurrentAmount(amount);
              setPercent(percent(amount, singleProject?.minAmount));
            }}
          />
        </Assets>
      </Box>
      <Box
        width="100%"
        marginTop="-30px"
        paddingLeft="20px"
        paddingRight="20px"
        marginBottom="10px"
      >
        <ProjectInvertButtons
          mb={0}
          disabled={isVipUser}
          fontSize={12}
          padding="10px"
          minWidth="150px"
          color={categorization?.color}
          variant={typeColorByProjectType[singleProject?.projectType]}
          maxWidth="calc(50% - 5px)"
          onInvertClick={handleInvertModal}
          justify={(
            isBigPhone
            && singleProject.status === projectStateType.OPEN)
            && (!isLogin || type === userType.USER)
            && 'space-around'}
          onSimulateClick={() => setShowInvestorSimulator(true)}
          {...singleProject}
        />
      </Box>
      <Box>
        <ProjectDescription
          isDesktop={false}
          isSmall={!isBigPhone}
          color={categorization?.color}
          singleProject={singleProject}
        />
      </Box>
      <Title size={16} isCenter mb={21}>
        Condiciones de inversión
      </Title>
      <InvestmentConditions
        project={singleProject}
        color={categorization?.color}
      />
      <Box
        marginTop="21px"
        paddingTop="25px"
        paddingLeft="30px"
        paddingRight="30px"
        paddingBottom="20px"
        ref={descriptionTeamRiskRef}
        bgcolor={colors.background.GRAY_3}
      >
        <Grid item xs={12}>
          <Title isCenter size={16} mb={20}>
            Conoce el proyecto
          </Title>
        </Grid>
        <ProjectDetails
          {...singleProject}
          color={categorization?.color}
          activeItem={detailsActiveItem}
          clearActiveItem={() => setDetailsActiveItem()}
        />
      </Box>
      <Box
        paddingLeft="30px"
        paddingRight="30px"
        paddingBottom="30px"
        bgcolor={colors.background.GRAY_3}
      >
        <Grid item xs={12} ref={descriptionTeamRiskRef}>
          <Title isCenter size={16} mb={30}>
            {`Conoce a ${singleProject?.companyName}`}
          </Title>
        </Grid>
        <ProjectMeetCompany
          color={categorization?.color}
          {...singleProject}
        />
      </Box>
      <Box
        width="100%"
        marginTop="20px"
        paddingLeft="30px"
        paddingRight="30px"
        marginBottom="30px"
      >
        <ProjectInvertButtons
          color={categorization?.color}
          variant={typeColorByProjectType[singleProject?.projectType]}
          disabled={isVipUser}
          onInvertClick={handleInvertModal}
          onSimulateClick={() => handlerSimulator()}
          {...singleProject}
        />
      </Box>
      <Box
        width="100%"
        paddingLeft="20px"
        paddingRight="20px"
        marginBottom="50px"
      >
        <ProjectInfoCards
          color={categorization?.color || colorByProjectType[singleProject?.projectType]}
        />
      </Box>
      {showInvestorSimulator && (
        <MobileSimulator
          handleClose={() => handlerSimulator()}
          project={singleProject}
        />
      )}
      <SignUp isOpen={isOpenModal.signUp} onClick={handleCloseModal} />
      {isOpenModal.investor && (
      <RegisterChecker check onClose={handleCloseModal}>
        <InvertModal
          isOpen
          currencyIso={singleProject?.currencyIso}
          projectId={singleProject?.projectId}
          name={singleProject?.projectName}
          userData={user?.info}
          currentAmount={currentAmount}
          handleGoRisk={() => {
            handleCloseModal();
            handleGoRisks();
          }}
          onSuccessfulInvert={(amount) => {
            setCurrentAmount(amount);
            setPercent(percent(amount, singleProject?.minAmount));
          }}
          isLogin={isLogin}
          minInvestmentAmount={singleProject?.minInvestmentAmount}
          companyName={singleProject?.companyName}
          onChange={handleCloseModal}
          onClick={handleCloseModal}
          project={singleProject}
        />
      </RegisterChecker>
      )}
      <Container mb={30} mt={20}>
        {/*
          <div style={{ width: '100%' }}>
            <Box display="flex" flexDirection="row" justifyContent="center" height="100%"
            width="100%" mt={2}>
              <Box>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ width: '300px' }}>
                      <Hollow
                        size={11}
                        onClick={handleOpen}
                        isSubmit
                        fullWidth
                      >
                        Simulador
                      </Hollow>
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </div>
      */}
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          align="center"
          fullWidth="md"
          maxWidth="md"
          style={{ borderRadius: '40px' }}
        >
          <DialogContent style={{ borderRadius: '40px' }}>
            <DialogTitle>
              <Grid container>
                <Grid item xs={2} align="left">
                  <Figure onClick={handleClose} height="15px" width="25px">
                    <img
                      style={{ cursor: 'pointer', marginTop: '10px' }}
                      src={arrowLeft}
                      alt="arrowLeft"
                    />
                  </Figure>
                </Grid>
                <Grid item xs={8}>
                  <Title number={5} color={colors.GRAY_1}>
                    Simula tu inversión en la campaña:
                  </Title>
                </Grid>
                <Grid item xs={2} align="right">
                  <CloseIcon
                    onClick={handleClose}
                    style={{ cursor: 'pointer', marginTop: '5px' }}
                    width="20px"
                    height="20px"
                  />
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContentText>
              <Div
                backgroundColor={colors.GRAY_7}
                color={colors.GRAY_2}
                radius="20px"
                width="700px"
                height="120px"
                mb={5}
              >
                <div>
                  <Grid container>
                    <Grid item sm={5}>
                      <Title
                        number={4}
                        color={colors.GRAY_9}
                        style={{ marginTop: '15px', marginLeft: '15px' }}
                      >
                        {singleProject?.projectName}
                      </Title>
                    </Grid>
                    <Grid item sm={1}>
                      <Divider
                        style={{
                          marginTop: '10px',
                          height: '95px',
                          backgroundColor: '#828282',
                          width: '2px',
                        }}
                        orientation="vertical"
                        flexItem
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <Box
                        display="flex"
                        flexDirection="row"
                        justifyContent="center"
                        height="60px"
                        width="100%"
                      >
                        <Box>
                          <Row>
                            <Title
                              number={6}
                              color={colors.GRAY_9}
                              dangerouslySetInnerHTML={{ __html: nameStatus }}
                              style={{ marginTop: '15px' }}
                            />
                          </Row>
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="row"
                        justifyContent="center"
                        height="50px"
                        width="300px"
                      >
                        <Box>
                          <Row fullWidth>
                            <Grid container>
                              <Grid item sm={4}>
                                <Text number={5} color={colors.GRAY_9}>
                                  Meta:
                                  <Text number={5} color={colors.GRAY_9}>
                                    {formatNumber(singleProject.goal)}
                                  </Text>
                                </Text>
                              </Grid>
                              <Grid item sm={4}>
                                <Text number={5} color={colors.GRAY_9}>
                                  Duración:
                                </Text>
                                <Text number={5} color={colors.GRAY_9}>
                                  {singleProject.days}
                                  {' '}
                                  días
                                </Text>
                              </Grid>
                              <Grid item sm={4} align="right">
                                <Text
                                  style={{ marginLeft: '15px' }}
                                  number={5}
                                  color={colors.GRAY_9}
                                >
                                  Inversiones realizadas:
                                  <Text number={5} color={colors.GRAY_9}>
                                    {singleProject.currentInvestorsAmount}
                                    {' '}
                                    Inversionistas
                                  </Text>
                                </Text>
                              </Grid>
                            </Grid>
                          </Row>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </div>
              </Div>
              <Title number={4} color={colors.GRAY_9}>
                Condiciones de Inversión
              </Title>
              <div
                style={{ width: '75%', textAlign: 'left', marginTop: '20px' }}
              >
                <Grid container>
                  <Grid item xs={4}>
                    <Text number={4}>Tasa:</Text>
                    <SubTitle number={4}>
                      {singleProject.percent}
                      % E.A.
                    </SubTitle>
                  </Grid>
                  <Grid item xs={4}>
                    <Text number={4}>Plazo:</Text>
                    <SubTitle number={4}>
                      {durationMonths}
                      {' '}
                      Meses
                    </SubTitle>
                  </Grid>
                  <Grid item xs={4}>
                    <Text number={4}>Período de gracia de intereses:</Text>
                    <SubTitle number={4}>No aplica</SubTitle>
                  </Grid>
                </Grid>
              </div>
              <div
                style={{ width: '75%', textAlign: 'left', marginTop: '15px' }}
              >
                <Grid container>
                  <Grid item xs={4}>
                    <Text number={4}>Pago Intereses:</Text>
                    <SubTitle number={4}>
                      {singleProject.paymentPeriod}
                    </SubTitle>
                  </Grid>
                  <Grid item xs={4}>
                    <Text number={4}>Pago Capital:</Text>
                    <SubTitle number={4}>
                      {singleProject.paymentPeriod}
                    </SubTitle>
                  </Grid>
                  <Grid item xs={4}>
                    <Text number={4}>Período de gracia de capital:</Text>
                    <SubTitle number={4}>No aplica</SubTitle>
                  </Grid>
                </Grid>
              </div>
              <Title number={4} color={colors.GRAY_9}>
                ¿Cuánto quieres invertir?
              </Title>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="center"
                height="50px"
                width="270px"
              >
                <Box>
                  <InputNumber
                    name="goal"
                    onChange={handleSimulationChange}
                    placeholder="Ingresa el valor"
                    fullWidth
                  />
                </Box>
              </Box>
              <Div
                backgroundColor={colors.primary}
                color={colors.WHITE}
                radius="20px"
                width="700px"
                height="100px"
                mb={5}
              >
                <div style={{ padding: '10px' }}>
                  <Text color={colors.WHITE} number={4}>
                    Valores aproximados de inversión *
                  </Text>
                </div>
                <CalculationSimulatorController {...simulationInfo}>
                  {({ goal, FixedFee, totalPaid }) => (
                    <div>
                      <div style={{ textAlign: 'left', marginLeft: '30px' }}>
                        <Grid container>
                          <Grid item sm={4}>
                            <Text color={colors.WHITE} number={4}>
                              Recibes en total:
                              <br />
                              {formatNumber(totalPaid)}
                            </Text>
                          </Grid>
                          <Grid item sm={4}>
                            <Text color={colors.WHITE} number={4}>
                              Ganas:
                              <br />
                              {formatNumber(totalPaid - goal)}
                            </Text>
                          </Grid>
                          <Grid item sm={4}>
                            <Text color={colors.WHITE} number={4}>
                              Recibes Periódicamente:
                              <br />
                              {formatNumber(FixedFee[0])}
                            </Text>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  )}
                </CalculationSimulatorController>
              </Div>
              <div
                style={{
                  width: '280px',
                  marginBottom: '20px',
                  marginTop: '20px',
                }}
              >
                <Hollow fullWidth size={12} onColorType={hollowColorType.GRAY}>
                  Invertir
                </Hollow>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ backgroundColor: colors.primary }}>
            <Grid container>
              <Grid item sm={2} />
              <Grid item sm={8}>
                <Text number={4} color={colors.WHITE} align="center">
                  * Recuerda que estos valores son aproximados y pueden variar
                  en un proceso real de financiación colaborativa.
                </Text>
              </Grid>
              <Grid item sm={2} />
            </Grid>
          </DialogActions>
        </Dialog>
      </Container>
      <Container md="60%">
        <Line top={40} />
      </Container>
      {projects.filter(
        (project) => project?.projectId !== singleProject?.projectId
          && project?.maxAmount !== project?.currentAmount,
      ).length > 0 && (
        <Container mt={20} mb={20} md="60%" lg="60%">
          <Title number={3} isCenter mb={20}>
            También te puede interesar
          </Title>
          <ListOfProject
            isDesktop={isDesktop}
            isLoading={isLoadingProjects}
            useCategorizationColors={from === 'categorization'}
            projects={projects.filter(
              (project) => project?.projectId !== singleProject?.projectId
                && project?.maxAmount !== project?.currentAmount,
            )}
          />
        </Container>
      )}
    </div>
  );
};
